<template>
	<div v-show="show" class="vue-pop">
      <div class="vue-pop-list">
        <div class="vue-pop-hd">{{title}}</div>
        <div class="vue-pop-bd" id="scroller-wraper">
          <div class="vue-pop-bd-inner" id="scroller">
            <ul>
              <li v-for="(item,index) in list" v-on:tap="select(index)" v-bind:class="selectindex===index?'vue-pop-on':''">
                <span class="vue-pop-text">{{item.text}}</span>
                <span class="vue-pop-ico" v-if="selectindex===index"></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="vue-pop-cover" v-on:click="hide"></div>
  </div>

</template>
<style lang='less'>
  @import 'pop-list.less';
</style>
<script type="text/javascript">
/*
@pop_show  是否展示弹窗
@list_data 弹窗数据格式，[{
        "id":1,
        "text":"数据"
      }............]
@pop_index 当前选中的索引
@impress 触发事件返回2个参数：第一个是选中的索引；第二个参数是false（关闭弹窗）

注：页面存在多个弹窗时，只需要传递不同的参数即可。不必多次调用该组件，减少DOM，优化内存
*/
import IScroll from '../../../js/iscroll.js'
export default {
    name: 'pop-list',
    data(){
      return{
        scrollHeight:0
      };
    },
    props: {
        list: {
            type: null,
            default: [{
                'id': 'id',
                'text': 'text'
            }]
        },
        selectindex: {
            type: Number,
            default: -1
        },
        title: {
            type: null,
            default: '请选择'
        },
        show: {
            type: Boolean,
            default: false
        }

    },
    watch:{
      show:function(newval){
          var _this = this;
          if(newval){
            this.scrollHeight = document.body.scrollTop;
            console.log('scrollHeight-'+this.scrollHeight);
            this.setLayout();
            document.documentElement.style.cssText = 'height:'+document.documentElement.clientHeight+'px;overflow:hidden;';
            document.body.style.cssText = 'height:'+document.documentElement.clientHeight+'px;overflow:hidden;';

            this.$nextTick(function(){
              g_scroll.refresh();
            });

          }else{
            // deal with layout
            document.documentElement.style.cssText = 'height:auto;overflow:auto;';
            document.body.style.cssText = 'height:auto;overflow:auto;';
            window.scrollBy(0,_this.scrollHeight);

          }
      }
    },
    mounted:function(){
        window.g_scroll = new IScroll('#scroller-wraper', { mouseWheel: false,tap: true });

    },
    methods: {
        setLayout:function(){
          // 列表最大高度
          document.getElementById('scroller-wraper').style.cssText = 'height:'+(this.list.length>5?5:this.list.length)*55 + 'px;';
        },
        select: function(index){
            this.$emit('impress',index,false);
        },
        hide: function(){
            this.$emit('impress',this.selectindex,false);
        }
    }
};
</script>



// WEBPACK FOOTER //
// ../common-npm/flyme7/component/pop-list/pop-list.vue